<template>
  <div id="app" class="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App root component
</script>

<style>
/* Global app styles are handled in main.css */
</style>